module.exports = __webpack_public_path__ + "static/sport/btn-bg.f5664e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/euro/btn-bg.png
// module id = s3TH
// module chunks = 0